import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
      <p class="mb-3">
        Mi vekiĝis hodiaŭ kun ia stranga sento. 
        Ĉio ĉirkaŭe ŝajnis al mi subite grandigita kaj iom kurbiĝinta, kun oscilantaj konturoj. 
        "Do, la tempo venis." – pensis mi. 
        Malsato forestis, sed tre urĝis emo min duŝi, kvankam kutime mi banas min vespere. 
        Sed la juko subhaŭte fariĝis neeltenebla, kaj mi ekhastis sub rigidajn fortajn striojn.
      </p>

      <p class="mb-3">
        La supra haŭto mirinde facile malgluiĝis de mi kaj per tavoloj falis subpieden. 
        Mi enŝovis ĝin en specialan lukon por elĵetaĵoj, kiun mi malfermis en la vando de la bankuvo. 
        Poste mi malriglis alian, ege pli grandan lukon, kiu troviĝis en la kento de l’ bankuvo super la elfluilo. 
        Sed antaŭe mi scivole ĉirkaŭrigardis min: kia ja mi fariĝis nun? 
        Mankis tempo pririgardi longe, ĉar la brakoj jam komencis transformiĝi en naĝilojn, 
        kaj se mi prokrastus ankoraŭ kelkajn minutojn, 
        mi jam ne sukcesus malfermi lukojn sen ekstera helpo kaj simple sufokiĝus en aero. 
        Por tiu kazo estis antaŭviditaj specialaj porkrizaj valvoj; sed kutime neniu uzis ilin, 
        ĉar ĉiuj proceduroj de la Transiro estis tiom bone ellaboritaj dum multfojaj trejnadoj, 
        ke oni faris ilin tute aŭtomate; 
        des pli ke la amasregaj medioj konstante subtenis la nivelon de la mensa stato de l’ loĝantaro, 
        sufiĉan por aŭtomata plenumo de ĉiuj necesaj funkcioj. 
      </p>

      <p class="mb-3">
        Spirhaltinte por ne veneniĝi per aero, mi plonĝis en grandan lukon kaj, kuntrenita de akvofluo, 
        eknaĝis antaŭen. 
        Mi naĝis longe, kaj laŭvoje pli kaj pli facile sentis min en akvo. 
        La korpo plilongiĝis kaj platiĝis de flankoj, iĝinte perfekte flulinia; la kapo, triangula kaj akra, 
        rapide penetris tra densa akvomaso. 
        La kruroj-brakoj transformiĝis en elastajn naĝilojn, tiel obeeme kaj senpene turnantaj min diversdirekten! 
        Mi ne plu sentis mian pezon, 
        mi estis libera en mia medio kaj povis moviĝi ne nur antaŭen-malantaŭen aŭ flanken, 
        sed ankaŭ supren kaj malsupren! 
        Neimagebla sento de libereco kaptis min. 
        Jen por kio mi estis kreita! 
        Ne devas mi esti estaĵo de dudimensia mondo, ĉiam katenita al la grundo per gravito; 
        ne, fin-fine mi akiris mian veran formon kaj atingis plenan posedon de mia korpo! 
        Mi estas libera! 
      </p>

      <p class="mb-3">
        La tunelo finiĝis, kaj mi alnaĝis en grandan basenon, kie ekvidis multajn similajn al mi. 
        Ili naĝadis, plonĝis, elsaltis el akvo, brilante sub hela suno per siaj olivecaj korpoj. 
        Ili simple vivoĝojis; kaj ankaŭ mi ĝojis tiel forte, tiel plene, 
        kiel neniam antaŭe sur tiu seka kaj plata tero. 
      </p>

      <p class="mb-3">
        Mi kunfluiĝis kun mia medio: la akvo estis kaj sube, kaj supre, kaj ĉirkaŭ mi; mi spiris per ĝi, 
        ĝi subtenis min, donis al mi fortojn vivi. 
        Neniam aero kaj tero donis al mi tian senton de la ĉiopovo, forteco kaj plenĝojo de vivo. 
        Jen ĝi, mia vera MI, jen por kio mi estas naskita! 
      </p>

      <p class="mb-3">
        Super ni ĉiam lumis la Suno, en la akvo jen kaj jen aperadis solvitaj nutraĵoj; 
        niaj ekskreciaĵoj estis forportataj per konstanta malforta fluo, tiel ke la akvo ĉiam restis pura. 
        Komence mi nur ĝuis tiun liberon kaj la senton de kunfluiĝo kun la tuta mondo, kun ĉio, 
        kio min ĉirkaŭas sur nia planedo kaj ekster ĝi. 
        Poste aperis deziro de io alia, iu celo, iu rezulto de apliko de tiu grandega forto, 
        kiun mi eksentis en mi mem. 
      </p>

      <p class="mb-3">
        Mi sciis, ke iam venos la tempo por apliki tiun forton; 
        kaj iun tagon mi ekvidis en la muro de nia baseno malfermitan lukon, kiun ne rimarkis antaŭe. 
        Mi alnaĝis al ĝi kaj per malvasta kanalo trafis en alian basenon. 
        Ĝiaj muroj estis signife pli altaj ol en la nia; tiel altaj, ke la ĉielo, limigita de tiuj muroj. 
        Ŝajnis de tie malgranda kiel kusenujo. 
        Kaj strange, ĝuste ĉar estis tiom malmulte da ĝi, la ĉielo forte allogis, vokis al si. 
        Aperis deziro elsalti el tiuj muroj, enpikiĝi en ĉielon, sin dissolvi en ĝi… 
        Kaj mi, kaj aliuj saltadis pli kaj pli alten, strebante supren. 
      </p>

      <p class="mb-3">
        Kaj jen, iuj lasis en la akvo sian belan tegaĵon, elgrimpis el ĝi kaj elflugis supren kiel iuj monstroj: 
        la korpo bastonforma, anstataŭ multaj perfektaj naĝiloj – du iaj grandegaj longaj plumpaj elstaraĵoj… 
        Kaj per tiuj elstaraĵoj ili baraktis en aero, frapadis – kaj la aero subtenis ilin! 
        Do ili ne pereis, ne sufokiĝis, sed leviĝis alten, kaj poste tute malaperis de la vido, 
        dissolvinte en tiu altega senfunda ĉielo!
      </p>

      <p class="mb-3">
        Kiel forta estis deziro sekvi ilin, kiel logis min tiu senlimo! Kaj iutage mi, 
        forĵetinte kiel sentaŭgan ujon mian tegaĵon, leviĝis en aeron… 
        kaj la aero ne bruligis min! Ĝi enfluis en min kiel aroma ondo, 
        kaj mi eksentis mirindan liberecon kaj senpezon. 
        Ĉu la vivo en solida akvo povis doni tian liberon?? 
        Ĉu tiu pezeco ne obsedis min ĉiam, kvankam tiam mi ne rimarkis tion? 
        Jen ĝi, libero kaj absoluta potenco en libera flugo, en senpezeca medio, 
        kiam ankaŭ mia korpo estas senpeza! 
        Jen kie plena kuniĝo kun ĉiuj fortoj de la Tero! 
        Jen apogeo de la vivo! 
        La Suno donas al ni forton; kaj la tutan saĝon kaj forton de la antikva Kosmo sorbis mia senpeza korpo. 
      </p>

      <p class="mb-3">
        Longe mi giris en senlima ĉielo; sed jen mia korpo komencis peziĝi. 
        Io min tiris suben, venis deziro ektuŝi la teron, kunfluiĝi kun ĝi, eksenti ĝian pezon. 
        Tro multe da forto kaj scio akumuliĝis en mi: ili postulis profundon, sinkon en ion pezegan, solidan, 
        fortan, ke mia medio estu same peza, pliriĉigita de ĉio kion mi ricevis dum la tuta tempo de mia vivo… 
        Solida kaj peza kuŝis en mi tiu scio; en solida kaj peza substrato devis ĝi konsolidiĝi kaj, 
        fin-fine maturiĝinte, liberiĝi, eliri el mi. 
        Mi, kiel obuso, flulinia kaj ŝtalfandita, perdis ĉiujn elstaraĵojn kaj flugilojn kaj enpikiĝis, 
        enpenetris en la teron, borante ĝin per akroforma kapo. 
        Kia ĝojo esti forta en forto, firma en firmo!
      </p>

      <p class="mb-5">
        Kaj jen ĉiuj miaj deziroj estingiĝis; mi atingis la finon de miaj vojaĝoj. 
        Mia vica tegaĵo krevis, kaj amaseto da molaj ovoj kovritaj de duontravidebla ŝelo restis en la grundo. 
        Same kiel porkoj elsnufas trufojn, la speciale dresitaj bestoj elsnufas freŝajn ovarojn, 
        kaj baldaŭ tiuj ovoj estis trovitaj kaj senditaj en inkubatoron. 
        Tie, sub gardo de Homoj, kiuj konstruis tiujn inkubatorojn kaj ĝenerale ĉion kio estis konstruita ĝis tiu tempo sur la Tero kaj en la Kosmo, 
        el tiuj ovoj elbrediĝis novaj Homoj, pliriĉigitaj per la fortoj de ĉiuj kvar elementoj kaj per scio de ĉiuj leĝoj de la vivo sur la Tero, 
        per kompreno de la fortoj agantaj en la mondo. 
      </p>

      <p class="mb-3">
        Homoj vivis, laboris, agadis… 
        Kaj poste venis la momento, kiam la tuta korpo komencis juki, kaj aperis deziro veni sin duŝi…
      </p>
    `
  )
}

const itemName = {
  esp: 'Ĉu vere ni bezonas multajn seksojn?',
  forLink: 'Ĉu vere ni bezonas multajn seksojn'
}


const item = {
  itemlink: getLink(itemName.forLink),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item; 



 
                                                                                         
